import { render, staticRenderFns } from "./formBeritaAcara.vue?vue&type=template&id=641008d2&"
import script from "./formBeritaAcara.vue?vue&type=script&lang=js&"
export * from "./formBeritaAcara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports